(function() {
  let lastDiscountAmount = 0;
  let lastCartState = '';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  function initialize() {
    setInterval(checkCartState, 1000);
    
    document.addEventListener('click', function(e) {
      if (e.target.closest('[href="/cart"]') || 
          e.target.closest('.js-cart-trigger') || 
          e.target.closest('.cart-link')) {
      }
    });
    
    setInterval(() => {
      moveDiscountBadgeToTitle();
      fixSingleLightOption();
      checkAndUpdateCart();
    }, 100);
  }
  
  function checkCartState() {
    const cartContainer = document.getElementById('CartContainer');
    if (!cartContainer) return;
    
    const currentState = cartContainer.innerHTML.length;
    if (currentState !== lastCartState) {
      lastCartState = currentState;
      checkAndUpdateCart(false);
    }
  }
  
  function checkAndUpdateCart(forceUpdate = false) {
    return false;
    let discountSummary = document.querySelector('.wb-discount-summary');
    if (discountSummary) return;

    discountSummary = document.createElement('div');
    discountSummary.className = 'wb-discount-summary';
    discountSummary.style.padding = '10px 15px';
    discountSummary.style.marginBottom = '0px';
    discountSummary.style.borderRadius = '8px';
    discountSummary.style.backgroundColor = '#f9f9f9';
    discountSummary.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
    
    const cartRows = document.querySelectorAll('#ajaxCartForm .cart-products .cart__row');
    let totalQuantity = 0;
    cartRows.forEach(row => {
      const productId = row.getAttribute('data-product-id');
      const quantity = parseInt(row.querySelector("input.qty-input").value);
      if (productId === "7226713276475") {
        totalQuantity += quantity;
      }
    });
    let discountPercent = 45;
    if (totalQuantity >= 2 && totalQuantity <= 3) discountPercent = 50;
    if (totalQuantity >= 4 && totalQuantity <= 5) discountPercent = 55;
    if (totalQuantity >= 6) discountPercent = 60;
    
    // Update crossed prices based on the current discount percent
    updateCrossedPrices(cartRows, discountPercent);
    
    discountSummary.innerHTML = `
      <div class="grid grid--full grid--no-gutters">
        <div class="grid__item medium-up--two-thirds">
          <p class="text-secondary">Bundle Discount:</p>
        </div>
        <div class="grid__item medium-up--one-third text-right">
          <p class="text-sale"><b>-${discountPercent}%</b></p>
        </div>
      </div>
    `;
    
    const cartForm = document.querySelector('#ajaxCartForm');
    if (cartForm) {
      const cartItems = cartForm.querySelector('.cart-products');
      if (cartItems && (!discountSummary.parentElement || 
          discountSummary.parentElement !== cartItems.parentElement || 
          discountSummary.nextElementSibling !== cartItems)) {
        cartItems.parentElement.insertBefore(discountSummary, cartItems);
      }
    }
  }
  
  function updateCrossedPrices(cartRows, discountPercent) {
    // First check if we have any matching product rows
    let hasTargetProduct = false;
    let targetRows = [];
    
    cartRows.forEach(row => {
      const productId = row.getAttribute('data-product-id');
      if (productId === "7226713276475") {
        hasTargetProduct = true;
        targetRows.push(row);
      }
    });
    
    if (!hasTargetProduct) return;
    
    // Apply background color to rows if discount > 45%
    if (discountPercent > 45) {
      targetRows.forEach(row => {
        row.style.backgroundColor = 'rgba(106, 153, 78, 0.1)'; // Light shade of #6a994e
      });
    }
    
    // Set loading state for crossed prices
    targetRows.forEach(row => {
      const crossedPriceElem = row.querySelector('.cart__price.cart__price--compare.text-strike > .money');
      if (crossedPriceElem) {
        crossedPriceElem.textContent = '';
      }
    });
    
    // Fetch product data from the API
    fetch('https://lainnovative.com/products/luminouspro.js')
      .then(response => response.json())
      .then(productData => {
        if (!productData || !productData.variants || productData.variants.length === 0) return;
        
        // Process each cart row that matches our target product
        cartRows.forEach(row => {
          const productId = row.getAttribute('data-product-id');
          if (productId !== "7226713276475") return;
          
          // Find the size information in the cart item
          const sizeElement = row.querySelector('div:has( > .cart__product-name) > p');
          if (!sizeElement) return;
          
          const sizeText = sizeElement.textContent.toLowerCase();
          
          // Determine which variant this cart item corresponds to
          let variantIndex = -1;
          if (sizeText.includes('small')) {
            variantIndex = 0; // Small (.5 Ft)
          } else if (sizeText.includes('medium')) {
            variantIndex = 1; // Medium (1 Ft)
          } else if (sizeText.includes('large')) {
            variantIndex = 2; // Large (1.5 Ft)
          }
          
          if (variantIndex === -1) return;
          
          // Get the compare at price for this variant
          const variant = productData.variants[variantIndex];
          if (!variant || !variant.compare_at_price) return;
          
          const compareAtPrice = variant.compare_at_price / 100; // Convert from cents to dollars
          
          // Find the crossed price element
          const crossedPriceElem = row.querySelector('.cart__price.cart__price--compare.text-strike > .money');
          if (!crossedPriceElem) return;
          
          // Get the currency symbol from the existing price
          const currencySymbol = crossedPriceElem.textContent.trim().replace(/[\d,.-]/g, '')[0] || '$';
          
          // Get quantity from the cart input
          const quantityInput = row.querySelector('.qty-input.cart__product-qty');
          const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
          
          // Calculate the adjusted compare price based on the quantity
          let adjustedComparePrice = compareAtPrice * quantity;
          
          // Update the crossed price with the formatted value
          const formattedComparePrice = currencySymbol + adjustedComparePrice.toFixed(2);
          crossedPriceElem.textContent = formattedComparePrice;
        });
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
      });
  }
  
  function moveDiscountBadgeToTitle() {
    var wb_fix_reviews_label = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--wb_fix_reviews_label"));
    if (wb_fix_reviews_label === 1 && document.body.getAttribute("id") === "luminous-pro") {
      const discountSavedElement = document.querySelector('.product-single__meta .dbtfy-discount_saved');
      if (!discountSavedElement) return;
      
      const productTitleContainer = document.querySelector('.product-title-container > div');
      if (!productTitleContainer) return;
      
      if (productTitleContainer.querySelector('.dbtfy-discount_saved')) return;
      
      const productTitle = productTitleContainer.querySelector('h1');
      if (!productTitle) return;
      
      productTitleContainer.appendChild(discountSavedElement);
    }
  }

  function fixSingleLightOption() {
    var wb_fix_single_light_option = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--wb_fix_single_light_option"));
    if (wb_fix_single_light_option === 1) {
      const optionsForm = document.querySelector('.product-single__meta #new-form');
      if (optionsForm) {
        let copiedButton = optionsForm.querySelector('.product-single__meta #new-form p.p-title-WB+div [data-add-to-cart]');
        if (copiedButton) return;
        const addToCartButton = optionsForm.querySelector('[data-add-to-cart]');
        const priceNewForm = optionsForm.querySelector('.product-single__meta #new-form p.p-title-WB+div .price-new-form');
        if (addToCartButton && priceNewForm) {
          const newElement = document.createElement('div');
          const newParentElement = priceNewForm.parentElement;
          copiedButton = addToCartButton.cloneNode(true);
          copiedButton.innerHTML = "";
          newElement.appendChild(priceNewForm);
          newElement.appendChild(copiedButton);
          newParentElement.appendChild(newElement);

          copiedButton.addEventListener('click', function(e) {
            setTimeout(function() {
              e.preventDefault();
              addToCartButton.click();
            }, 100);
          });
        }
      }
    }
  }
})();
